"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FooterCell2Widget {
    constructor(row, column, widget) {
        this.row = row;
        this.column = column;
        this.widget = widget;
        // Intentionally left empty - properties defined through constructor injection
    }
}
exports.default = FooterCell2Widget;
//# sourceMappingURL=FooterCell2Widget.js.map